<div class="schedule" (scroll)="scroll_cooloff()">

	@for( g of core.games; track g.id ) {

		<div id="clock_element" class="clock" *ngIf="clock_before_gid == g.id" [class.merged]="!clock_unmergable && date_before_gids.has(g.id)">
			<span>
				Now {{ schedule.clock_datetime | tzdate:'HH : mm : ss' }}
				<span class="tz"> ({{ schedule.tz_label }})</span>
			</span>

		</div>

		<div class="date-sep" *ngIf="date_before_gids.has(g.id)"></div>

		@let status = g.get_status_display().toLowerCase();
		@let prediction = user.predictions[g.id] || 0;
		@let is_predictable = g.is_predictable && prediction == 0;
		@let prediction_teams = get_prediction_teams(prediction);
		@let team_spoiler = g.are_teams_spoilable() && prediction == 0;
		<div class="game" [class]="status">

			<span class="badges">
				<span class="badge"
					*ngFor="let b of g.badges"
					[class.spoiler]="team_spoiler && b.startsWith('G')">
					{{ b }}
				</span>
			</span>

			<span class="info" *ngIf="g.is_unavailable">!</span>

			<span class="date" *ngIf="date_before_gids.has(g.id)" [class.merged]="!clock_unmergable && clock_before_gid == g.id">
				{{ g.datetime | tzdate:'MMM dd' }}
				@if( schedule.relative_day_name( g.datetime ); as day_name ){
					- {{ day_name }}
				} @else if( clock_unmergable && clock_before_gid == g.id ) {
					<small class="upcomming">in {{ schedule.relative_day_count( g.datetime ) }} days</small>
				}
			</span>

			@if( g.tags.includes("TBD") ) {
				@if( g.start_datetime ){
					<span class="time">{{ g.start_datetime | tzdate:'HH:mm (TT)' }}</span>
				} @else {
					<span class="time"> To be Decided </span>
				}
			} @else {
				<span class="time">{{ g.datetime | tzdate:'HH:mm (TT)' }}</span>
			}


			<span class="teams" [class.spoiler]="team_spoiler" [class.predicted]="prediction" [class.beating]="predict_beating.has(g.id)" >
				@for( t of g.teams; track t.id; let idx = $index ){

					<span class="team"
						(click)="predict_toggle( g, idx )"
						[class.predictable]="is_predictable"
						[class.predicted]="prediction_teams[idx]">
						<span class="shadow"></span>

						<span class="prediction" *ngIf="prediction_teams[idx]">x{{ prediction_teams[idx] }}</span>
						<img [src]="t.logo" [alt]="t.abbreviation" [style.padding.px]="t.padding"/>

						@if( is_predictable ){
							@let points = prediction_abs_for(g, idx);
							<span class="plus" [class.close]="points == 4"><i class="material-icons">add</i></span>
							<span class="predicting" *ngIf="points">{{ points }}/4 Points</span>
						}

						<span class="abr"><span>{{ t.abbreviation }}</span></span>
					</span>
				}
			</span>

				@if ( "WS".includes( g.status ) ){
					<footer>
						@if( is_predictable ){
							<button class="predict" (click)="predict( g )">
								PREDICT
								<span class="rotating material-icons" *ngIf="predict_loading.has(g.id)">autorenew</span>
							</button>
						} @else if( prediction ) {
							<span class="status">PREDICTED</span>
						} @else {
							<span class="status small">NOT FOR PREDICTING</span>
						}
					</footer>
				} @else {
					<footer [class.is_spoilable]="g.is_spoilable()" [class.delete_spoilers]="settings.delete_spoilers" [class.is_scored]="g.is_scored()">
						<span class="score away">
							<span>{{ g.away_score | number: "2.0" }}</span>
							<i class="material-icons" [style.transform]="get_transform_style_for(-g.id)">tag</i>
						</span>
						<span class="status">{{ g.get_status_display() }}</span>
						<span class="score home">
							<span>{{ g.home_score | number: "2.0" }}</span>
							<i class="material-icons" [style.transform]="get_transform_style_for(+g.id)">tag</i>
						</span>
					</footer>
				}
		</div>
	}

</div>
